import JadwalService from '@/services/jadwal'

export default {
	namespaced: true,
	state: {
		events: [],
		productJasa: [],
		allProductJasa: null
	},
	mutations: {
		SET_EVENTS(state, events) {
		  state.events = events
		},
		SET_PRODUCT_JASA(state, productJasa) {
		  state.productJasa = productJasa
		},
		SET_ALL_INFO_PRODUCT_JASA(state, allProductJasa) {
		  state.allProductJasa = allProductJasa
		}
	},
	actions: {
		async cekJadwal({ commit, state, getters, dispatch }, payload) {
			try {
				let response = await JadwalService.cekJadwal(payload)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async createJadwal({ commit, state, getters, dispatch }, payload) {
			try {
				let response = await JadwalService.createJadwal(payload)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async updateJadwal({ commit, state, getters, dispatch }, payload) {
			try {
				let response = await JadwalService.updateJadwal(payload.id, {...payload})
				return response
			} catch (e) {
				console.log(e)
			}
		},
	}
};
